import { useEffect, useState } from 'react';
import { getPublicCatalog } from '../../lib/api';
import { siteIdentity } from '../../content/siteContent';
import { wpPages } from '../../content/wpPages.generated';
import { CatalogGrid } from '../components/CatalogGrid';
import { BlockRenderer } from '../components/BlockRenderer';
import type { CatalogItem } from '../../lib/types';

export function CatalogPage() {
  const [items, setItems] = useState<CatalogItem[]>([]);

  useEffect(() => {
    getPublicCatalog().then(setItems).catch(() => setItems([]));
  }, []);

  const introBlocks = wpPages.services?.blocks.filter((block) => block.type !== 'heading') ?? [];

  return (
    <section className="catalog-page">
      <header className="page-hero">
        <p className="eyebrow">{siteIdentity.name}</p>
        <h1>{siteIdentity.catalogLabel}</h1>
      </header>
      {introBlocks.length > 0 && <section className="prose"><BlockRenderer blocks={introBlocks} /></section>}
      <CatalogGrid items={items} />
    </section>
  );
}
